// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__hJdiR","resendInfoText":"OnGoingPaymentBox_resendInfoText__16n-N"};